import React, { useState } from 'react';

import icon1 from '../../assets/images/chart/color_1.png'
import icon2 from '../../assets/images/chart/color_2.png'
import icon3 from '../../assets/images/chart/color_3.png'
import icon4 from '../../assets/images/chart/color_4.png'
import { Chart } from './Chart';

function Token(props) {

    const [data] = useState(
        [
            {
                id: 1,
                img: '/assets/cerv/about/simulador-vr-operacion.png',
                title: 'Cursos E-Learning desarrollados',
                number: '41'
            },
            {
                id: 2,
                img: '/assets/cerv/about/simulador-vr-seguridad.png',
                title: 'Simuladores VR seguridad y mantenimiento desarrollados',
                number: '34'
            },
            {
                id: 3,
                img: '/assets/cerv/about/cursos-elearning.png',
                title: 'Simuladores VR operación equipo desarrollados',
                number: '5'
            }
        ]
    )

    const [list] = useState(
        [
            {
                id: 1,
                icon: icon1,
                title: 'Plataforma de E-learning',
                unit: '17903'
            },
            {
                id: 2,
                icon: icon2,
                title: 'Simuladores VR seguridad y mantenimiento',
                unit: '12828'
            },
            {
                id: 3,
                icon: icon3,
                title: 'Simuladores VR operación de equipo',
                unit: '1567'
            },
            {
                id: 4,
                icon: icon4,
                title: 'Componentes del SIC',
                unit: '665'
            }
        ]
    )

    const [dataTitle] = useState(
        {
            title: 'Nuestro impacto',

        }
    )
    return (
        <section className="tf-section tf-token py-4">
            <div className="overlay" style={{
                background: "linear-gradient(rgb(16 9 62) 3.92%, rgba(9, 18, 29, 0) 36.79%, rgb(24 11 55) 83.98%), url('/assets/images/backgroup/bg_pagetitle.png') center center no-repeat",
                backgroundSize: "cover",
                width: "100%",
                height: "100%",
                position: "absolute",
                top: 0,
                left: 0
            }}>
            </div>
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <div className="tf-title" data-aos="fade-up" data-aos-duration="800">
                            <h2 className="title">
                                {dataTitle.title}
                            </h2>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="row">
                            <div className="counter_wrapper d-flex align-items-center">
                                <div>
                                    {
                                        data.map(idx => (
                                            <div key={idx.id} className="box flex w-full md:w-1/2 lg:w-1/3">
                                                <div className="image image-container flex-shrink-0 w-1/5">
                                                    <img src={idx.img} alt={idx.title} className="object-contain" />
                                                </div>
                                                <div className="content flex-grow w-4/5 pl-4">
                                                    <p className="desc text-lg font-semibold">{idx.title}</p>
                                                    <div className="box-couter counter mt-2">
                                                        <div className="number-content text-2xl font-bold">
                                                            <span className="count-number" data-to="359" data-speed="2000" data-inviewport="yes">{idx.number}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                            <div className="char_wrapper">
                                <ul className="describe_chart d-flex align-items-center justify-content-center flex-wrap">
                                    <div className="d-flex flex-wrap justify-content-center">
                                        {
                                            list.map(idx => (
                                                <li key={idx.id} className="w-full md:w-1/2 lg:w-1/4">
                                                    <img src={idx.icon} alt={idx.title} className="w-full h-auto" />
                                                    <div className="desc">
                                                        <p className="name text-lg font-semibold">{idx.title}</p>
                                                        <p className="number text-2xl font-bold">{idx.unit}</p>
                                                    </div>
                                                </li>
                                            ))
                                        }
                                    </div>
                                </ul>
                                <div className="chart_inner" data-aos="fade-up" data-aos-duration="800">
                                    <Chart />
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </section>
    );
}

export default Token;